import {
  Paper,
  Stack,
  TextField,
  Typography,
  Button,
  Autocomplete,
  Container,
  Alert,
  AlertTitle,
  ImageList,
  ImageListItem,
  IconButton,
} from "@mui/material";
import Page from "../components/Page";
import { useState, useEffect, useRef, useCallback } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import { getDevices } from "src/api/devices";
import {
  addFaceDetails,
  getContractorsByLocation,
  getDepartmentsByLocation,
  registerFaceManually,
  registerFaceStatus,
  registerWithSelectedImages,
  registerFaceUpdate,
  updateUserDataFc,
} from "src/api/faceRegistration";
import { getFullURL } from "src/utils/config";
import { LoadingButton } from "@mui/lab";
import VideoReStream from "src/components/VideoReStream";
import Iconify from "src/components/Iconify";
import { Link } from "react-router-dom";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { getURL } from "src/utils/config";
import axios from "axios";
import { uploadImagedData } from "src/api/addAgent";

const steps = [
  "Add User Details",
  "Straight-On Capture",
  "Up Profile Capture",
  "Down Profile Capture",
];

const getCollectionData = (data, keys) => {
  if (Array.isArray(data)) {
    return data;
  }

  const collection = keys.map((key) => data?.[key]).find((value) => Array.isArray(value));

  if (collection) {
    return collection;
  }

  return data ? [data] : [];
};



const normalizeDepartmentOptions = (departments) =>
  getCollectionData(departments, ["data", "departments", "Departments"])
    .map((departmentItem) => {
      if (typeof departmentItem === "string") {
        return {
          DepartmentId: null,
          DepartmentName: departmentItem.trim(),
        };
      }

      return {
        DepartmentId: departmentItem?.DepartmentId,
        DepartmentName:
          departmentItem?.DepartmentName ??
          departmentItem?.departmentName ??
          departmentItem?.Department ??
          departmentItem?.department ??
          departmentItem?.Name ??
          departmentItem?.name ??
          "",
        ...departmentItem,
      };
    })
    .filter((item) => item.DepartmentName);

const normalizeContractorOptions = (contractors) =>
  getCollectionData(contractors, ["data", "contractors", "Contractors"])
    .map((contractorItem) => {
      if (typeof contractorItem === "string") {
        return {
          ContractorId: null,
          ContractorName: contractorItem.trim(),
        };
      }

      return {
        ContractorId: contractorItem?.ContractorId,
        ContractorName:
          contractorItem?.ContractorName ??
          contractorItem?.contractorName ??
          contractorItem?.Contractor ??
          contractorItem?.contractor ??
          contractorItem?.Name ??
          contractorItem?.name ??
          "",
        ...contractorItem,
      };
    })
    .filter((item) => item.ContractorName);



// const normalizeDepartmentOptions = (departments) =>
//   getCollectionData(departments, ["data", "departments", "Departments"])
//     .map((departmentItem) => {
//       if (typeof departmentItem === "string") {
//         return departmentItem.trim();
//       }

//       return String(
//         departmentItem?.DepartmentName ??
//         departmentItem?.departmentName ??
//         departmentItem?.Department ??
//         departmentItem?.department ??
//         departmentItem?.Name ??
//         departmentItem?.name ??
//         ""
//       ).trim();
//     })
//     .filter(Boolean);

// const normalizeContractorOptions = (contractors) =>
//   getCollectionData(contractors, ["data", "contractors", "Contractors"])
//     .map((contractorItem) => {
//       if (typeof contractorItem === "string") {
//         return contractorItem.trim();
//       }

//       return String(
//         contractorItem?.ContractorName ??
//         contractorItem?.contractorName ??
//         contractorItem?.Contractor ??
//         contractorItem?.contractor ??
//         contractorItem?.Name ??
//         contractorItem?.name ??
//         ""
//       ).trim();
//     })
//     .filter(Boolean);

// ----------------------------------------------------------------------



const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.dark,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.dark,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
  [`& .${stepConnectorClasses.root}`]: {
    // borderColor: '#eaeaf0',
    borderTopWidth: 3,
    // borderColor: theme.palette.success.dark,
    color: "red",
    backgroundColor: theme.palette.success.dark,
    borderRadius: 1,
  },
}));

const CustomImageListItem = styled(ImageListItem, {
  shouldForwardProp: (prop) => !["success"].includes(prop),
})(({ success, theme }) => ({
  ...(success && {
    border: "3px solid",
    borderColor: theme.palette.success.dark,
    backgroundColor: "#fbfff5",
    color: theme.palette.success.dark,
  }),
  "&:hover": {
    border: "3px solid",
    borderColor: theme.palette.success.main, // Change border color on hover
    cursor: "pointer", // Show pointer cursor
  },
}));

const step1_Instruction = [
  {
    imgPath: "./static/faces/straight.png",
    title: "Looks directly at the camera",
    content:
      "Position yourself in front of the camera and look straight ahead. This will help us recognize your face more accurately.",
  },
  {
    imgPath: "./static/faces/straight_left.png",
    title: "Slightly turn left your face",
    content:
      "Adjust your position by turning your face slightly to the left. This helps improve accuracy.",
  },
  {
    imgPath: "./static/faces/straight_right.png",
    title: "Slightly turn right your face",
    content:
      "To optimize recognition, turn your face gently to the right. Make sure to keep eye contact with the camera.",
  },
];

const step2_Instruction = [
  {
    imgPath: "./static/faces/up_straight.png",
    title: "Slightly chine up your face",
    content:
      "Adjust your position by raising your chin a little as shown in the image. This helps improve accuracy",
  },
  {
    imgPath: "./static/faces/up_left.png",
    title: "Slightly turn left your face",
    content:
      "Adjust your position by turning your face slightly to the left as shown in the image. This helps improve accuracy.",
  },
  {
    imgPath: "./static/faces/up_right.png",
    title: "Slightly turn right your face",
    content:
      "Adjust your position by turning your face slightly to the right as shown in the image. This helps improve accuracy.",
  },
];

const step3_Instruction = [
  {
    imgPath: "./static/faces/down_straight.png",
    title: "Slightly head down",
    content: "Please slightly lower your head, as shown in the image",
  },
  {
    imgPath: "./static/faces/down_left.png",
    title: "Slightly turn left your face",
    content: "Slightly turn left your face",
  },
  {
    imgPath: "./static/faces/down_right.png",
    title: "Slightly turn right your face",
    content: "Slightly turn right your face",
  },
];

export default function FaceRegistration() {
  const [activeStep, setActiveStep] = useState(0);
  const [cameras, setCameras] = useState([]);
  const [faceData, setFaceData] = useState({
    name: "",
    id: null,
    isLoading: false,
  });
  const [streamCamera, setStreamCamera] = useState(null);
  const [baseURL, setBaseURL] = useState(null);
  const [capturedImages, setCapturedImages] = useState([]);

  // const [images, setImages] = useState([]);
  //Buttons
  const [disableGetButton, setDisableButton] = useState(false);
  const [disableTextField, setDisableText] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const [locationNames, setLocationNames] = useState([]); // Initialize as an empty array

  const [locationError, setLocationError] = useState(false);

  const [apiData, setApiData] = useState(null); // New state for storing API data

  const [error, setError] = useState("");

  // const reStreamImg = useRef(null)
  const [faceAngleStep, setFaceAngleStep] = useState({
    step: 0,
    isProcess: false,
    status: null,
    images: [],
    is_display_instruction: false,
    stepIndexing: 0,
    message: null,
  });

  const [streamStatus, setStreamStatus] = useState(null);

  const [selectedIMages, setImgSelection] = useState({ active: [], all: [] });

  const [ipAddress, setIpAddress] = useState("");

  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState(null); // New state to stor
  const [imageConvertedData, setImageData] = useState("");
  const [finalImageURL, setFinalImage] = useState("");

  const [contractor, setContractor] = useState(null);
  const [department, setDepartment] = useState(null);

  const [contractorList, setContractorList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [captureResetKey, setCaptureResetKey] = useState(0);
  const contractorRequestIdRef = useRef(0);
  const departmentRequestIdRef = useRef(0);


  const updateLocation = useCallback((value) => {
    setSelectedLocation(value);
    const selectedLocationObject = apiData?.find((location) => location.LocationName === value);
    const locationId = selectedLocationObject ? selectedLocationObject.Id : null;

    setSelectedLocationId(locationId);
    if (locationId) {
      localStorage.setItem("NetLocation", value);
    } else {
      localStorage.removeItem("NetLocation");
    }

    setContractor(null);
    setDepartment(null);
    setContractorList([]);
    setDepartmentList([]);

    const contractorRequestId = contractorRequestIdRef.current + 1;
    const departmentRequestId = departmentRequestIdRef.current + 1;
    contractorRequestIdRef.current = contractorRequestId;
    departmentRequestIdRef.current = departmentRequestId;

    if (!locationId) {
      return;
    }

    getContractorsByLocation({ location_id: locationId }, (response) => {
      if (contractorRequestIdRef.current !== contractorRequestId) return;

      if (response.status === 200) {
        setContractorList(normalizeContractorOptions(response.data));
      } else {
        setContractorList([]);
      }
    });

    getDepartmentsByLocation({ location_id: locationId }, (response) => {
      if (departmentRequestIdRef.current !== departmentRequestId) return;

      if (response.status === 200) {
        setDepartmentList(normalizeDepartmentOptions(response.data));
      } else {
        setDepartmentList([]);
      }
    });
  }, [apiData]);

  
  useEffect(()=>{
    const savedLocation = localStorage.getItem("NetLocation");
    if(savedLocation && apiData) {
        updateLocation(savedLocation);
    }
  },[apiData, updateLocation])

  const handleLocationChange = (value) => {
    updateLocation(value);
  };

  const handleIpAddress = (event) => {
    setIpAddress(event.target.value);
  };

  // const handleGetIP1 = (ipAddress) => {
  //   const validIP = /^(\d{1,3}\.){3}\d{1,3}$/; // Simple regex for validating IPv4 addresses

  //   if (validIP.test(ipAddress)) {
  //     console.log("Valid IP Address:", ipAddress);

  //     const port = process.env.REACT_APP_PORT;
  //     console.log("Port from .env:", port);

  //     const apiUrl = `http://${ipAddress}:${port}/`;
  //     console.log("Calling API:", apiUrl);

  //     fetch(apiUrl)
  //       .then((response) => {
  //         if (response.status === 200) {
  //           setDisableButton(true);
  //           setErrorMessage(""); // Clear any previous error
  //           return response.json(); // Return parsed JSON data
  //         } else {
  //           setErrorMessage(`Error: HTTP ${response.status}`);
  //           throw new Error(`HTTP Error: ${response.status}`);
  //         }
  //       })
  //       .then((data) => {
  //         console.log("API Response:", data.live_url);
  //         setStreamCamera(data.live_url);
  //       })
  //       .catch((error) => {
  //         console.error("API Error:", error);
  //         setErrorMessage("Please enter a valid IP address"); // Set error message in case of failure
  //       });
  //   } else {
  //     console.error("Invalid IP Address:", ipAddress);
  //     setErrorMessage("Invalid IP format. Please enter a valid IP address.");
  //   }
  // };

  const handleGetIP = (ipAddress) => {
    // Updated regex to validate IP addresses correctly
    const validIP =
      /^(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})$/;

    if (validIP.test(ipAddress)) {
      // console.log("Valid IP Address:", ipAddress);

      const port = process.env.REACT_APP_PORT;
      // console.log("Port from .env:", port);

      const apiUrl = `http://${ipAddress}:${port}/`;
      // console.log("Calling API:", apiUrl);

      fetch(apiUrl)
        .then((response) => {
          if (response.status === 200) {
            localStorage.setItem("netIP", ipAddress);
            setDisableButton(true);
            setErrorMessage(""); // Clear previous errors
            return response.json();
          } else {
            setErrorMessage(`Error: HTTP ${response.status}`);
            throw new Error(`HTTP Error: ${response.status}`);
          }
        })
        .then((data) => {
          // console.log("API Response:", data.live_url);
          setStreamCamera(data.live_url);
          setBaseURL(data.face_detection_base_url);
          localStorage.setItem("deleteURL",data.face_detection_base_url);
        })
        .catch((error) => {
          console.error("API Error:", error);
          setErrorMessage(
            "Please enter a valid IP address or check network connection."
          );
        });
    } else {
      console.error("Invalid IP Address:", ipAddress);
      setErrorMessage("Invalid IP format. Please enter a valid IPv4 address.");
    }
  };

  const handleStep = (step) => {
    setFaceData((lastData) => {
      return { ...lastData, isLoading: true };
    });
    addFaceDetails(
      baseURL,
      {
        Name: faceData.name,
        LocationId: selectedLocationId,
        ContractorId: contractor?.ContractorId,
        DepartmentId: department?.DepartmentId,
      },
      (status, response) => {
        if (status && response.status === 200) {
          if (response.data.hasOwnProperty("FaceId")) {
            setFaceData((lastData) => {
              return {
                ...lastData,
                id: response.data.FaceId,
                isLoading: false,
              };
            });
          }
          setActiveStep(step + 1);
        }
      }
    );
  };

  const handleFaceName = (event) => {
    setFaceData((lastData) => {
      return { ...lastData, name: event.target.value };
    });
  };

  useEffect(() => {
    const storedIp = localStorage.getItem("netIP");
    if (storedIp) {
      setIpAddress(storedIp);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const apiUrl = getURL("employee-shifts-info/location-names?status=1");
      const AUTH_TOKEN = `${localStorage.getItem(
        "token_type"
      )} ${localStorage.getItem("access_token")}`;

      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: AUTH_TOKEN,
          },
        });

        const extractedLocationNames = response.data.map(
          (item) => item.LocationName
        );
        setLocationNames(extractedLocationNames);

        setApiData(response.data);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    getDevices({ status: 1 }, (response) => {
      if (response.status === 200)
        setCameras([
          {
            deviceid: 0,
            devicename: "Web Camera",
            substream: "0",
            fps: 30,
          },
          ...response.data,
        ]);
    });
  }, []);

  const handleCameras = (_, value) => {
    // console.log(value);
    setStreamCamera(value);
    // reStreamImg.current.url = getFullURL(`video-feed?stream_url=${encodeURIComponent(value.substream)}&client_id=${localStorage.getItem('client_id')}&fps=${value.fps}`, 'FACE_API')
  };

  const resetCapture = () => {
    setStreamStatus(null);
    setCapturedImages([]);
    setCaptureResetKey(prev => prev + 1);
  };

  const handleInstruction2Preview = () => {
    resetCapture();
    // console.log("===== one ")
    setDisableText(true);
    setFaceAngleStep((lastSetup) => ({
      ...lastSetup,
      is_display_instruction: false,
      stepIndexing: lastSetup.stepIndexing + 1,
    }));
    setCapturedImages([]);
  };

  const retryRegistration = () => {
    setFaceAngleStep((lastStep) => {
      return { ...lastStep, status: null };
    });

    setCapturedImages([]);
  };

  useEffect(() => {
    if (
      capturedImages.length >= 7 &&
      !faceAngleStep.isProcess &&
      faceAngleStep.stepIndexing === 1 && faceAngleStep.status !== 'fail'
    ) {
      
      handleFaceRegistration();
    }
  }, [capturedImages]);

  useEffect(() =>{
    if(activeStep === 4 ){
      const data = {
        status: "continue",
      };
      registerFaceStatus(data, (response) => {
        if (response.status === 200) {
          //console.log("continue");
        }
      });
    }

  },[activeStep])

  const handleFaceRegistration = () => {
   //console.log("===============", faceAngleStep);
   //console.log('capturedImages:',JSON.stringify(capturedImages))
    setFaceAngleStep((lastStep) => ({
      ...lastStep,
      isProcess: true,
      status: null,
      is_display_instruction: false,
      message: null,
    }));

    const faceRegister = {
      client_id: localStorage.getItem("client_id"),
      user_id: faceData.id,
      images: [...capturedImages],
    };

    // console.log('faceRegister:',JSON.stringify(faceRegister))

    registerFaceManually(faceRegister, baseURL, (response) => {
      if (
        response.status === 200 &&
        String(response.data.message).toLocaleLowerCase() === "success"
      ) {
        // console.log(
        //   "=============",
        //   faceAngleStep.step,
        //   faceAngleStep.stepIndexing,
        //   activeStep
        // );
        if (
          faceAngleStep.step === 0 &&
          faceAngleStep.stepIndexing === 1 &&
          activeStep === 1
        ) {
          const data = {
            status: "pause",
          };
          registerFaceStatus(data, (response) => {
            if (response.status === 200) {
              // console.log("pause");
            }
          });
        }

        setFaceAngleStep((lastStep) => {
          return {
            ...lastStep,
            isProcess: false,
            status: "success",
            images: response.data.detected_faces,
            is_instruction_completed: false,
            stepIndexing: lastStep.stepIndexing + 1,
          };
        });
        // setCapturedImages([]);
      } else {
        setFaceAngleStep((lastStep) => {
          return {
            ...lastStep,
            isProcess: false,
            status: "fail",
            message: response.data.hasOwnProperty("message")
              ? response.data.message
              : "Somthing went wrong please try again.",
          };
        });
      }
    });
  };

  const handleSelectedFaces = () => {
    // console.log("Captured images ",capturedImages);
    setError("");
    setImgSelection((lastSelectedImages) => {
    const finalSelectedImages = {
      ...lastSelectedImages,
      all: [
        ...new Set([...lastSelectedImages.all, ...lastSelectedImages.active]),
      ],
      active: [],
    };
    
      //console.log("final Selecetd images",finalSelectedImages,faceAngleStep.step,activeStep);
      if (
        finalSelectedImages.length !== 0 &&
        faceAngleStep.step === 0 &&
        activeStep === 1
      ) {
        // console.log("selected Images",finalSelectedImages.all[0]);
        let arr = finalSelectedImages.all[0]; // string: "377/2025_04_09_10_35_27_705759.jpg"
        let converted = arr.replace("/", "_"); // ✅ Correct usage
        // console.log("final converted image", converted);
        const imgPath = finalSelectedImages.all[0];
        // createFileFromImagePath(imgPath);
        const imageUrl = `${faceAngleStep.images[0].base_url}/${imgPath}`; // Full image URL
        const img = new Image();
        img.crossOrigin = "anonymous"; // Necessary if image is from a different origin
        img.src = imageUrl;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          canvas.toBlob((blob) => {
            if (blob) {
              const file = new File([blob], `${converted}`, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });

              // console.log("Created file:", file);

              const image_file = {
                file_path: 'NeterWala',
                file: file,
              };

              //console.log('image_file:',image_file);


              uploadImagedData(image_file, (response) => {
                if (response.status === 200) {
                  //console.log("image Data response:", response.data);
                  setImageData(response.data);

                  const profileImage = response.data.url;

                  //const instance = process.env.REACT_APP_DEV_IMAGE_API;
                  //console.log("instance",instance);
                  //const imageConvertedData  = response.data.url;
                  //console.log("imageConvertedData",imageConvertedData);
                  // const baseUrl = "/modelstore/storage";

                  // const imageConvertedData = response.data.url.replace(
                  //   baseUrl,
                  //   ""
                  // );

                  //const newImagePath = `${instance}${imageConvertedData}`;
                 // console.log('profileImage:',profileImage);
                  setFinalImage(profileImage);
                }
              });
            }
          }, "image/jpeg");
        };
      }

      //console.log('finalSelectedImages:', finalSelectedImages);
      return finalSelectedImages;
    });

    let faceRegAngleStep = faceAngleStep.step + 1;
    if (faceRegAngleStep === 3 && activeStep !== 3) {
      setActiveStep((lastActiveSteps) => lastActiveSteps + 1);
      faceRegAngleStep = 0;
    }

    //console.log('finalImageURL:', finalImageURL);  

    if (faceRegAngleStep === 3 && activeStep === 3) {
      registerWithSelectedImages(
        baseURL,
        {
          selected_paths: selectedIMages.all.toString(),
          client_id: String(localStorage.getItem("client_id")),
          user_id: String(faceData.id),
        },
        (response) => {
          if (response.status === 200 || response.status === 201) {
            // if(faceAngleStep.step === 2 && faceAngleStep.stepIndexing === 1 && activeStep === 3){
            //  }

            // console.log("final image loades picture",finalImageURL)
            setActiveStep((lastActiveSteps) => lastActiveSteps + 1);
            faceRegAngleStep = 0;
            const updateData = {
              Id: faceData.id,
              Name: faceData.name,
              ProcessStatus: 1,
              ProfileUrl: finalImageURL,
            };

            //console.log('profileImageUpload:', updateData);

            updateUserDataFc(updateData, (response) => {
              //console.log('profileImageResponse:',response)
              if (response.status === 200) {
                registerFaceUpdate((result) => {
                    if (result?.status === 200) {
                        console.log("Face update success:", result.data);
                    } else {
                        console.error("Face update failed:", result);
                    }
                });
              }
            });

            setCapturedImages([]);
          }
        }
      );
    } else {
      setCapturedImages([]);
      // console.log("response", response.data)
      setFaceAngleStep((lastStep) => {
        return {
          ...lastStep,
          isProcess: false,
          status: "success",
          step: faceRegAngleStep,
          is_display_instruction: true,
          stepIndexing: 0,
          images: [],
        };
      });
    }
  };


  const handleSelectImage = (imageURL) => {
    setError("");

    setImgSelection((lastList) => {
      const activeList = [...lastList.active];
      let updatedImages = [];

      if (activeList.includes(imageURL)) {
        // If image is already selected, remove it
        updatedImages = activeList.filter((img) => img !== imageURL);
      } else {
        // If not selected and less than 3 already selected, add it
        if (activeList.length >= 3) {
          setError("You can only select up to 3 images.");
          return lastList; // Return the previous state unchanged
        }
        updatedImages = [...activeList, imageURL];
      }

      // console.log("Images Selected:", updatedImages);
      return { ...lastList, active: updatedImages };
    });
  };

  // console.log("streamStatus", streamStatus)
  return (
    <Page title="Add New Face">
      <Container maxWidth="xxl" sx={{p:0}}>
        {/* Headder */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Box>
            <Typography variant="h4" gutterBottom>
              <IconButton component={Link} to="/face-list">
                <Iconify icon="eva:arrow-back-outline" />
              </IconButton>
              Register New Face
            </Typography>
            {/* <Typography>with a 4 steps</Typography> */}
          </Box>
        </Stack>
        {/* Stepper */}

        <Box sx={{ width: "100%" }}>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            connector={<QontoConnector />}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        <Box sx={{ height: 350 }}>
          {/* Step 1(add user) and 4 (sucess Note) */}
          {(activeStep === 0 || activeStep === 4) && (
            <Stack
              direction="column"
              spacing={2}
              sx={{
                justifyContent: "center",
                alignItems: "center",
                minHeight: 350,
              }}
            >
              <Box sx={{ minWidth: 500 }}>
                {activeStep === 0 && (
                  <>
                    <Typography sx={{ color: "gray", marginTop: 8 }} py={1}>
                      {/* Enter Location and name of the face register person */}
                      Enter the Below details to start the face register person
                    </Typography>

                    <FormControl fullWidth sx={{ minWidth: 0, marginTop: 2 }}>
                      <InputLabel
                        id="location-name-label"
                        sx={{ color: locationError ? "red" : "gray" }}
                      >
                        Location
                      </InputLabel>
                      <Select
                        labelId="location-name-label"
                        label="Location"
                        value={selectedLocation}
                        onChange={(e) => handleLocationChange(e.target.value)}
                        error={locationError}
                      >
                        {locationNames.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      sx={{ marginTop: 2 }}
                      fullWidth
                      label="Name"
                      onChange={handleFaceName}
                    />

                    <FormControl fullWidth sx={{ minWidth: 0, marginTop: 2 }}>
                      <InputLabel id="contractor-label">
                        Contractor Name
                      </InputLabel>
                      <Select
                          labelId="contractor-label"
                          value={contractor?.ContractorId ?? ""}
                          label="Contractor Name"
                          onChange={(e) => {
                            const selected = contractorList.find(
                              (item) => item.ContractorId === e.target.value
                            );
                            setContractor(selected);
                          }}
                        >
                          {contractorList.map((option) => (
                            <MenuItem
                              key={option.ContractorId}
                              value={option.ContractorId}
                            >
                              {option.ContractorName}
                            </MenuItem>
                          ))}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth sx={{ minWidth: 0, marginTop: 2 }}>
                      <InputLabel id="department-label">Department</InputLabel>
                     <Select
                        labelId="department-label"
                        value={department?.DepartmentId ?? ""}
                        label="Department"
                        onChange={(e) => {
                          const selected = departmentList.find(
                            (item) => item.DepartmentId === e.target.value
                          );
                          setDepartment(selected);
                        }}
                      >
                      {departmentList.map((option) => (
                        <MenuItem
                          key={option.DepartmentId}
                          value={option.DepartmentId}
                        >
                          {option.DepartmentName}
                        </MenuItem>
                      ))}
                    </Select>
                    </FormControl>




                    <Box sx={{ textAlign: "right", pt: 2 }}>
                      <LoadingButton
                        loading={faceData.isLoading}
                        //disabled={!faceData.name || selectedLocation === "" || contractor === "" || department === ""}
                        disabled={
                          !faceData.name ||
                          !selectedLocation ||
                          !contractor ||
                          !department
                        }
                        variant="contained"
                        onClick={() => handleStep(0)}
                      >
                        Continue
                      </LoadingButton>
                    </Box>
                  </>
                )}
                {activeStep === 4 && (
                  <Box sx={{ textAlign: "center" }}>
                    {/* <Iconify icon="eve:arrow-ios-downward-fill"/> */}
                    <Iconify
                      color={(theme) => theme.palette.success.dark}
                      icon={"eva:checkmark-circle-2-outline"}
                      sx={{ width: 80, height: 80, ml: 1 }}
                    />
                    <Typography variant="h6" sx={{ py: 2, color: "gray" }}>
                      Face recognition has been successfully <br /> completed.
                    </Typography>
                    <Button
                      component={Link}
                      to="/face-list"
                      variant="contained"
                      color="success"
                    >
                      Go to faces list
                    </Button>
                  </Box>
                )}
              </Box>
            </Stack>
          )}

          {[1, 2, 3].includes(activeStep) && (
            <Box>
              <Stack
                direction="row"
                spacing={10}
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                  py: 4,
                }}
              >
                <Stack direction="column" spacing={2}>
                  {/* IP Address */}
                  <Stack direction="row" spacing={2} alignItems="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="IP Address"
                      value={ipAddress}
                      onChange={handleIpAddress}
                      error={Boolean(errorMessage)} // Show error styling
                      helperText={errorMessage} // Display error message below TextField
                      // disabled={disableGetButton}
                      disabled={disableTextField && disableGetButton}
                    />

                    <Button
                      type="submit"
                      onClick={() => handleGetIP(ipAddress)}
                      variant="contained"
                      disabled={disableGetButton} // Disable button when true
                    >
                      Get
                    </Button>
                  </Stack>

                  {faceAngleStep.images.length > 0 ? (
                    <Box>
                      <Typography component="h5">
                        Kindly select a minimum of one and a maximum of three
                        options.
                      </Typography>
                      <ImageList sx={{ width: 500, height: 450 }} cols={3}>
                        {faceAngleStep.images.map((item, index) => (
                          <CustomImageListItem
                            onClick={() => handleSelectImage(item.file_path)}
                            success={selectedIMages.active.includes(
                              item.file_path
                            )}
                            key={index}
                          >
                            <img
                              src={`${item.base_url}/${item.file_path}`}
                              alt={item.file_path}
                              loading="lazy"
                            />
                          </CustomImageListItem>
                        ))}
                      </ImageList>

                      {error && (
                        <Typography color="error" sx={{ mt: 1 }}>
                          {error}
                        </Typography>
                      )}
                    </Box>
                  ) : (
                    // Instructions
                    [
                      ...(activeStep === 1
                        ? step1_Instruction
                        : activeStep === 2
                        ? step2_Instruction
                        : step3_Instruction),
                    ].map(
                      (instruction, index) =>
                        faceAngleStep.step === index &&
                        faceAngleStep.is_display_instruction && (
                          <Stack
                            direction="column"
                            spacing={3}
                            key={index}
                            sx={{
                              justifyContent: "center",
                              alignItems: "center",
                              py: 4,
                              width: 640,
                            }}
                          >
                            <Typography sx={{ fontWeight: 800 }}>
                              {instruction.title}
                            </Typography>
                            <Paper
                              src={instruction.imgPath}
                              sx={{ maxWidth: 120 }}
                              component="img"
                            />
                            <Typography sx={{ my: 2 }}>
                              {instruction.content}
                            </Typography>
                            <Box sx={{ textAlign: "right", width: "100%" }}>
                              {faceAngleStep.images.length === 0 ? (
                                <Button
                                  onClick={() => handleInstruction2Preview()}
                                  variant="contained"
                                >
                                  {activeStep === 1 &&
                                  index === 0 &&
                                  faceAngleStep.stepIndexing === 0
                                    ? "Let's Begin"
                                    : "Proceed"}
                                </Button>
                              ) : (
                                <Button variant="contained">Next</Button>
                              )}
                            </Box>
                          </Stack>
                        )
                    )
                  )}

                  {/* Preview  */}

                  <VideoReStream
                    key={captureResetKey}
                    streamStatus={streamStatus}
                    handleSteamStatus={setStreamStatus}
                    sx={{
                      width: 640,
                      minHeight: 350,
                      textAlign: "center",
                      display:
                        faceAngleStep.is_display_instruction ||
                        faceAngleStep.images.length > 0
                          ? "none"
                          : "block",
                    }}
                    // url={(streamCamera && streamCamera.hasOwnProperty('substream') && activeStep !== 4) ?
                    // getFullURL(`video-feed?stream_url=${encodeURIComponent(streamCamera.substream)}&client_id=${localStorage.getItem('client_id')}&fps=${streamCamera.fps}`, 'FACE_API'): ''} />
                    url={streamCamera}
                    capturedImages={capturedImages}
                    setCapturedImages={setCapturedImages}
                    // onImagesCaptured={handleCapturedImages}
                  />

                  {/* Failed Note */}
                  {faceAngleStep.status && faceAngleStep.status === "fail" ? (
                    <Box sx={{ width: 640 }}>
                      <Alert severity="warning">
                        <AlertTitle>Face registration failed!</AlertTitle>
                        {faceAngleStep.message}
                      </Alert>
                      <Box sx={{ mt: 2, textAlign: "right" }}>
                        <Button
                          disabled={
                            streamCamera &&
                            streamStatus &&
                            streamStatus === "playing"
                              ? false
                              : true
                          }
                          // onClick={() =>
                          //   handleFaceRegistration(
                          //     faceAngleStep.step,
                          //     activeStep
                          //   )
                          // }
                          onClick={
                            faceAngleStep.status &&
                            faceAngleStep.status === "fail"
                              ? () => retryRegistration()
                              : () => retryRegistration()
                          }
                          sx={{ ml: 1 }}
                          variant="contained"
                        >
                          Try Again
                        </Button>
                        {/* <Button disabled={streamCamera && streamStatus && streamStatus === 'playing' ? false : true}  sx={{ ml: 1 }} variant='contained' onClick={handleManualFaceRegistration} >Try Manually</Button> */}
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        textAlign: "right",
                        display: faceAngleStep.is_display_instruction
                          ? "none"
                          : "block",
                      }}
                    >
                      {faceAngleStep.isProcess ? (
                        <Button disabled={true} variant="contained">
                          Processing...
                        </Button>
                      ) : faceAngleStep.images.length === 0 &&
                        faceAngleStep.stepIndexing === 0 ? (
                        <Button
                          disabled={
                            streamCamera &&
                            streamStatus &&
                            streamStatus === "playing"
                              ? false
                              : true
                          }
                          variant="contained"
                          onClick={() =>
                            setFaceAngleStep((lastSetup) => ({
                              ...lastSetup,
                              is_display_instruction: true,
                            }))
                          }
                        >
                          {faceAngleStep.step === 0
                            ? "Start Register Face"
                            : "Next"}
                        </Button>
                      ) : faceAngleStep.stepIndexing === 2 ? (
                        <Button
                          disabled={
                            selectedIMages.active.length < 1 ? true : false
                          }
                          onClick={() => handleSelectedFaces()}
                          variant="contained"
                        >
                          Submit{" "}
                        </Button>
                      ) : (
                        // (<Button onClick={() => submitFaces(faceAngleStep.step, activeStep)} variant='contained'>Next</Button>)
                        <Button
                          // disabled={capturedImages.length < 7 ? true : false}
                          disabled={true}
                          // onClick={() => handleFaceRegistration()}
                          variant="contained"
                        >
                          {capturedImages.length < 7 &&
                          !faceAngleStep.isProcess &&
                          faceAngleStep.stepIndexing === 1
                            ? `Capturing...(${7 - capturedImages.length}s)`
                            : "Continue"}
                        </Button>
                      )}
                    </Box>
                  )}
                </Stack>
              </Stack>
            </Box>
          )}
        </Box>
      </Container>
    </Page>
  );
}
